import * as React from 'react';
export const defaultSetHref = (_newHref, _replace)=>undefined;
const defaultHrefContext = [
    '/',
    defaultSetHref
];
export default /*#__PURE__*/ React.createContext(defaultHrefContext);

//# sourceMappingURL=HrefContext.js.map